import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useClient } from 'jsonapi-react';
import { ExercisesQuestionsSidebar } from './exercises-questions-sidebar';
import { ExercisesQuestionsCard } from '@/pages/exercises/exercises-questions/exercises-questions-card';
import { Loader } from '@/components/custom/loader';
// import EndScroll from '@/components/custom/end-scroll/end-scroll';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { DashboardContent } from '@/layouts/dashboard';
import { QuestionList, QuestionSidebarWrapper } from '@/components/custom/question';
import { Button } from '@/components/ui/button';

export function ExercisesQuestions(props) {
  const { uri } = props;

  const client = useClient();
  const [pageNumber, setPageNumber] = useState(1);
  const [lastAnswerSubmited, setLastAnswerSubmited] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [questions, setQuestions] = useState([]);
  const [groupedQuestions, setGroupedQuestions] = useState();
  const [taxonomyIds, setTaxonomyIds] = useState([]);
  const [questionCount, setQuestionCount] = useState();
  const [questionBook, setQuestionBook] = useState();

  useEffect(() => {
    fetchQuestionBook();
  }, []);

  useEffect(() => {
    fetchData();
  }, [pageNumber]);

  useEffect(() => {
    fetchData(true);
  }, [taxonomyIds]);

  useEffect(() => {
    groupQuestionsByCode();
  }, [questions]);

  const fetchData = async clearData => {
    if (clearData && pageNumber !== 1) {
      setQuestions([]);
      return setPageNumber(1);
    }

    try {
      let filterIds = '';
      taxonomyIds.forEach(id => {
        filterIds = `${filterIds}&filter[taxonomies.id][]=${id}`;
      });

      const queryParams = props.id ? `&filter[question_book_id]=${props.id}` : '';
      //filter[visibility]=train&
      const { data, meta } = await client.fetch(`questions?page[number]=${pageNumber}&page[size]=10${filterIds}${queryParams}`);
      setQuestionCount(meta.total);
      if (data.length === 0) {
        setHasMore(false);
      }
      clearData ? setQuestions(data) : setQuestions([...questions, ...data]);
    } catch (e) {
      console.log(e);
    }
  };

  const groupQuestionsByCode = () => {
    if (questions.length > 0) {
      const groupedByCode = questions.reduce((result, item) => {
        (result[item.code] = result[item.code] || []).push(item);
        return result;
      }, {});
      setGroupedQuestions(groupedByCode);
    }
  };
  const fetchQuestionBook = async () => {
    if (props.id) {
      try {
        const { data } = await client.fetch(`question_books/${props.id}`);
        setQuestionBook(data);
      } catch (e) {
        console.log(e);
      }
    }
  };

  const clearFilters = () => {
    setTaxonomyIds([]);
  };

  const authorityLevel = useAuthorityLevel();

  const breadcrumbs = {
    title: 'Avaliações e Questões',
    nav: [
      {
        route: '/questions/apostilas',
        name: 'Exercícios',
        isActive: false
      },
      {
        route: uri,
        name: questionBook?.title,
        isActive: true
      }
    ]
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <QuestionList>
        {taxonomyIds.length > 0 && (
          <Button
            variant="outline"
            size="sm"
            className="mb-3"
            onClick={clearFilters}
          >
            Limpar filtros
          </Button>
        )}

        <InfiniteScroll
          dataLength={questions.length}
          next={() => setPageNumber(pageNumber + 1)}
          hasMore={hasMore}
          loader={<Loader />}
          // endMessage={<EndScroll />}
        >
          {groupedQuestions &&
            Object.entries(groupedQuestions).map(([key, groupedQuestion]) => (
              <ExercisesQuestionsCard
                key={key}
                groupedQuestion={groupedQuestion}
                taxonomyIds={taxonomyIds}
                setTaxonomyIds={setTaxonomyIds}
                updateLastAnswerSubmited={setLastAnswerSubmited}
              />
            ))}
        </InfiniteScroll>
      </QuestionList>

      <QuestionSidebarWrapper>
        {authorityLevel === 'student' && (
          <ExercisesQuestionsSidebar
            reply
            questionBook={questionBook}
            lastAnswerSubmited={lastAnswerSubmited}
          />
        )}
      </QuestionSidebarWrapper>
    </DashboardContent>
  );
}
